import React, { useEffect, useRef } from "react";
import { Link } from "gatsby";
import SEO from "../components/seo";
import SiteLayout from "../components/site/SiteLayout";
import EditLink from "../components/site/EditLink";
import { url as apiUrl } from "../api";
import { useInicio } from "../lib/inicio";
import { mediaUrl } from "../lib/content";

const HERO_SIZES = "100vw";
const heroSrcSet = (ext) =>
  `/assets/img/hero-aerial-640.${ext} 640w, /assets/img/hero-aerial-1000.${ext} 1000w, /assets/img/hero-aerial-1400.${ext} 1400w`;

function IndexPage() {
  const heroRef = useRef(null);
  const site = useInicio();
  // Imagem enviada pelo cliente substitui a capa padrão (que é servida em
  // avif/webp otimizados a partir de /static).
  const heroCustom = mediaUrl(apiUrl, site.heroImagem);

  useEffect(() => {
    // LCP element -- React 16 will not pass fetchpriority through as a prop.
    if (heroRef.current) {
      heroRef.current.setAttribute("fetchpriority", "high");
    }
  }, []);

  return (
    <SiteLayout>
      <SEO
        lang="pt-BR"
        keywords={[`Bivver`, `Empreendimentos`]}
        description="Bivver Empreendimentos: construímos lugares, concretizamos sonhos. Conheça nossos empreendimentos em Balneário Piçarras e Camboriú/SC."
        title="Bivver Empreendimentos — Litoral de Santa Catarina"
      />

      <EditLink to="/edicao/inicio" label="Editar textos do site" />

      <section className="home-hero">
        <div className="home-hero-media-wrap">
          {heroCustom ? (
            <img
              className="home-hero-media"
              src={heroCustom}
              alt="Bivver Empreendimentos"
              decoding="async"
            />
          ) : (
            <picture>
              <source type="image/avif" srcSet={heroSrcSet("avif")} sizes={HERO_SIZES} />
              <source type="image/webp" srcSet={heroSrcSet("webp")} sizes={HERO_SIZES} />
              <img
                ref={heroRef}
                className="home-hero-media"
                src="/assets/img/hero-aerial.jpg"
                width={1400}
                height={787}
                alt="Bivver Empreendimentos"
                decoding="async"
              />
            </picture>
          )}
        </div>
        <div className="home-hero-tagline-wrap">
          <p className="home-hero-tagline">
            {site.heroLinha1}
            <br />
            <span className="home-hero-tagline-accent">{site.heroLinha2}</span>
          </p>
          <Link className="home-hero-cta" to="/empreendimentos">
            {site.heroCta}
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}

export default IndexPage;
